import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { dashboardStyles } from "../appCss";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Image from "../../Image";
import { connect } from "react-redux";
import CustomLoading from "../CustomLoader";

class DisplayCards extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Card
        className="display-cards-paper"
        style={{ transition: "0.3s", cursor: this.props.onClick && "pointer" }}
        onClick={this.props.onClick}
      >
        <div className="display-cards">
          <Image
            src={`${this.props.image}`}
            style={{ height: 50 }}
            alt={this.props.name}
          />
        </div>
        <div className={classes.details} style={{ width: "60%" }}>
          <CardContent className={classes.content}>
            {!!this.props.values ? (
              <div
                style={{
                  fontFamily: "OpenSans-semiBold",
                  fontSize: 25,
                  textAlign: "center",
                  color: "#057cc9",
                }}
              >
                {this.props.values}
              </div>
            ) : (
              <CustomLoading
              type={"ThreeDots"}
              width={25}
              height={25}
            />
              
            )}

            <div
              style={{
                fontFamily: "OpenSans-semiBold",
                fontSize: 15,
                textAlign: "center",
                color: "#6d7278",
              }}
            >
              {this.props.name}
            </div>
          </CardContent>
        </div>
      </Card>
    );
  }
}

DisplayCards.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default connect(({ loading }) => {
  const { count } = loading;
  return { count };
})(withStyles(dashboardStyles)(DisplayCards));
